/* eslint-disable no-unreachable */
import { db } from "~/db/db";
import { useGetHierarquiasAprovacao } from "./useSimulacoes";
import { useEffect, useMemo, useRef, useState } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import usePrazoPagamento from "./usePrazoPagamento";

const useHierarquia = ({ descontosMaximo = [], prazos = [] }) => {

  const [hierarquias, setHierarquias] = useState([]);

  useEffect(() => {
    const fetchHierarquias = async () => {
      const result = [];
      await db.hierarquiasAprovacao.each((item) => result.push(item));
      setHierarquias(result);
    };

    fetchHierarquias();
  }, []);

  const formikRef = useRef();

  const { prazoPagamentos } = usePrazoPagamento({ formikRef });

  const hierarquiasAprovacaoMaxima = useMemo(() => {
    let desc = descontosMaximo.map((item) => {
      const thisHierarquia = [];

      const prazo = (prazos || []).find((a) => a.grupoProdutoId == item.grupoProdutoId);
      if (prazo) {
        const prazoPagamento = (prazoPagamentos || []).filter((a) => prazo.prazosPagamentoId.includes(a.id)).sort((a, b) => {
          return a.dias - b.dias
        }).pop();
        if (prazoPagamento) {
          thisHierarquia.push(hierarquias?.sort((a, b) => a.hierarquia - b.hierarquia).find((hierarquia) => hierarquia.grupoMaterialId == prazo.grupoProdutoId && hierarquia.dias && prazoPagamento.dias <= hierarquia.dias));
        }
      }
      const desconto = (item.descontos || []).sort((a, b) => a - b)[0];
      thisHierarquia.push(hierarquias?.find((hierarquia) => desconto >= hierarquia.desconto && hierarquia.grupoMaterialId == item.grupoProdutoId));

      return {
        ...item,
        hierarquia: thisHierarquia.sort((a, b) => b.hierarquia - a.hierarquia)[0]
      }
    })
    return desc;
  }, [descontosMaximo, prazoPagamentos, prazos, hierarquias])


  return {
    hierarquiasAprovacaoMaxima,
    hierarquias,
  }
}

export default useHierarquia;